// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3pPeoGUvuwCm4ESTfGwe4v","choicesDiv":"_2YzXTfjy2AsO5hp9YfbBaP","buttonDiv":"_1Nu0jH7mqoc7JEv-QxZt4V","buttonBack":"j0OHww2z5zkMy4IqU4oGp","buttonNext":"_1PZmJuOOgOEz-aYnf62aQ-","textarea":"_1q4eSX_7-4SrknT8ICzLFh","svg":"_2eDzL5Ag6wi7gjHNjTN5jE"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/Form/styles.scss
 ** module id = 410
 ** module chunks = 0
 **/